import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import IconDelete from 'material-ui/svg-icons/action/delete';

import DeletePlaceholderEmbed from '../DeletePlaceholderEmbed/DeletePlaceholderEmbed';

import mergeStates from '../../helpers/mergeStates';
import classes from './FormServiceKey.scss';
import { addFeedback } from '../../store/modules/feedback';
import { connect } from 'react-redux';
import { RaisedButton } from 'material-ui';

const mapActionCreators = {
  addFeedback,
};

const mapStateToProps = state => ({});

export class FormServiceKey extends React.Component {
  constructor(props) {
    super(props);

    const preppedServiceKey = {
      id: props.serviceKey.id !== null ? props.serviceKey.id : '',
      name: props.serviceKey.name !== null ? props.serviceKey.name : '',
      description:
        props.serviceKey.description !== null
          ? props.serviceKey.description
          : '',
    };

    const serviceTypes = [];
    _.forOwn(props.types, serviceType => {
      serviceTypes.push(serviceType);
    });

    this.state = {
      id: preppedServiceKey.id,
      name: preppedServiceKey.name,
      description: preppedServiceKey.description,
      types: serviceTypes,
    };

    setTimeout(() => this.focus(), 150);
  }

  componentWillReceiveProps(nextProps) {
    // if (typeof nextProps.selected !== 'undefined') {
    //   this.setState({
    //     selected: nextProps.selected
    //   });
    // }
  }

  focus = () => {
    if (this.primaryInput && this.primaryInput !== null) {
      this.primaryInput.focus();
    }
  };

  handleChange = e => {
    const nextState = mergeStates(e, this.state);
    this.setState(nextState);
  };

  handleTypeChange = (e, index) => {
    const currentTypes = this.state.types;
    currentTypes[index][e.target.name] = e.target.value;

    this.setState({
      types: currentTypes,
    });
  };

  save = () => {
    // // console.log(this.props.push);
    // return;

    // console.log(this.state);
    this.props.saveServiceKey(this.state);
    this.props.closeServiceKeyForm();
    this.props.push('/serviceKey/');
  };

  addNewServiceType = () => {
    const currentTypes = _.clone(this.state.types);

    currentTypes.push({
      index: this.state.types.length - 1,
      name: '',
      hourly_rate: '',
      description: '',
      rounding: 0,
      is_deletable: true,
    });

    this.setState({
      types: currentTypes,
    });
  };

  setDeleteFlag = (event, index, unset) => {
    const currentTypes = _.clone(this.state.types);

    if (currentTypes[index].is_deletable !== true) {
      return this.props.addFeedback(
        'error',
        'Leistungsart wird verwendet und kann daher nicht gelöscht werden!',
      );
    }
    if (typeof unset !== 'undefined' && unset === true) {
      currentTypes[index].delete_this_service_type = null;
    } else {
      currentTypes[index].delete_this_service_type = currentTypes[index].id;
    }
    this.setState({
      types: currentTypes,
    });
  };
  renderServiceType = (serviceType, index) => {
    if (
      typeof serviceType.delete_this_service_type !== 'undefined' &&
      serviceType.delete_this_service_type
    ) {
      return (
        <tr>
          <td colSpan="4">
            <DeletePlaceholderEmbed
              name={
                serviceType.name !== null ? serviceType.name : 'Leistungsart'
              }
              onCancel={e => this.setDeleteFlag(e, index, true)}
            />
          </td>
        </tr>
      );
    }

    let serviceTypeKey = 'service_key';
    if (this.state.id === 'undefined' || !this.state.id) {
      serviceTypeKey = `${serviceTypeKey}_new`;
    } else {
      serviceTypeKey = `${serviceTypeKey}_${this.state.id}`;
    }
    if (serviceType.id === 'undefined' || !serviceType.id) {
      serviceTypeKey = `${serviceTypeKey}_${serviceType.index}`;
    } else {
      serviceTypeKey = `${serviceTypeKey}_${serviceType.id}`;
    }

    return (
      <tr className={classes.row} key={serviceTypeKey}>
        <td>
          <input
            name="name"
            value={serviceType.name !== null ? serviceType.name : ''}
            onChange={e => this.handleTypeChange(e, index)}
          />
        </td>
        {/*<td>*/}
        {/*<textarea*/}
        {/*name="description"*/}
        {/*rows="2"*/}
        {/*cols="60"*/}
        {/*value={*/}
        {/*serviceType.description !== null ? serviceType.description : ''*/}
        {/*}*/}
        {/*onChange={e => this.handleTypeChange(e, index)}*/}
        {/*/>*/}
        {/*</td>*/}
        <td>
          <input
            name="hourly_rate"
            value={
              serviceType.hourly_rate !== null ? serviceType.hourly_rate : ''
            }
            type="number"
            onChange={e => this.handleTypeChange(e, index)}
            className={classes.numberInput}
          />
        </td>
        <td>
          <input
            name="rounding"
            value={serviceType.rounding !== null ? serviceType.rounding : ''}
            type="number"
            onChange={e => this.handleTypeChange(e, index)}
            className={classes.numberInput}
          />
        </td>
        <td>
          <span
            className={classes.formButton}
            onMouseDown={e => this.setDeleteFlag(e, index)}
          >
            <IconDelete /> Entfernen
          </span>
        </td>
      </tr>
    );
  };
  render() {
    let buttonText = 'Erstellen';
    if (this.state.id !== null) {
      buttonText = 'Speichern';
    }
    const actions = [
      <FlatButton
        label="Abbrechen"
        primary={false}
        onMouseDown={() => {
          this.props.closeServiceKeyForm();
        }}
      />,
      <RaisedButton
        style={{ marginLeft: 10 }}
        label={buttonText}
        primary
        disabled={this.state.name.trim().length === 0}
        onMouseDown={() => this.save()}
      />,
    ]; // // console.log(this.context); // const serviceTypes = this.props.types.map(serviceType => this.renderServiceType(serviceType)); // }); // // console.log(this.state); // // console.log(this.props.types, this.props, typeof this.props.types, this.state); // const serviceTypes = []; // // _.forOwn(this.state.types, (serviceType) => { //   serviceTypes.push(this.renderServiceType(serviceType));
    const serviceTypes = this.state.types.map((serviceType, index) =>
      this.renderServiceType(serviceType, index),
    );

    let title = 'Neue Leistungskategorie erstellen';
    if (
      typeof this.state.id !== 'undefined' &&
      this.state.id !== null &&
      this.state.name.length > 0
    ) {
      title = `"${this.state.name}" bearbeiten`;
    } else if (
      (typeof this.state.id === 'undefined' || this.state.id === null) &&
      this.state.name.length > 0
    ) {
      title = `"${this.state.name}" erstellen`;
    } else if (typeof this.state.id !== 'undefined' && this.state.id !== null) {
      title = 'Leistungskategorie bearbeiten';
    }
    return (
      <Dialog
        title={title}
        actions={actions}
        modal={false}
        open
        autoScrollBodyContent
        className="form modal-center"
        contentClassName="form-container form-container--service-key"
        titleClassName="form-header"
        actionsContainerClassName="form-footer"
        bodyClassName="form-body"
      >
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="name">
              Name
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <input
              name="name"
              value={this.state.name}
              onChange={e => this.handleChange(e)}
              ref={input => {
                this.primaryInput = input;
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="name">
              Beschreibung
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <textarea
              name="description"
              rows="2"
              cols="80"
              value={this.state.description}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>
        <div className="row flex-vcenter">
          <div className="col-xs-7 flex-vcenter">
            <h4>Leistungsarten</h4>
          </div>
          <div className="col-xs-5 text-right flex-vcenter">
            <RaisedButton
              label="Neue Leistungsart hinzufügen"
              primary
              onMouseDown={this.addNewServiceType}
            />
          </div>
        </div>

        <table className={classes.table}>
          <thead>
            <tr>
              <th>Name</th>
              {/*<th>Beschreibung</th>*/}
              <th width="150">Stundensatz</th>
              <th width="150">Taktung in Minuten</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>{serviceTypes}</tbody>
        </table>
      </Dialog>
    );
  }
}
FormServiceKey.propTypes = {
  serviceKey: PropTypes.object,
  types: PropTypes.object,
  push: PropTypes.func.isRequired,
  saveServiceKey: PropTypes.func.isRequired,
  closeServiceKeyForm: PropTypes.func.isRequired,
  addFeedback: PropTypes.func.isRequired,
};
FormServiceKey.defaultProps = {
  serviceKey: {
    name: '',
    description: '',
    types: [],
  },
  types: {},
};
export default connect(mapStateToProps, mapActionCreators)(FormServiceKey);



// WEBPACK FOOTER //
// ./src/components/FormServiceKey/FormServiceKey.js